module.exports = __webpack_public_path__ + "static/media/light_logo.956378ef.png";